import xmlUtils from '@/utils/XmlUtils.vue'

export default {
  toXml: (key, res) => {
    const response = xmlUtils.methods.getParseObjectFromXml(res.data)
    if ([1, 96].includes(+response[key].ErrorCode._text)) {
      return new Promise(resolve => resolve(response))
    } else {
      return new Promise((resolve, reject) => {
        if (+response[key].ErrorCode._text === 2000) {
          reject(response[key])
        } else if (response[key].hasOwnProperty('ErrorDetails') && Object.keys(response[key].ErrorDetails).length > 0) {
          reject(response[key])
        } else if (response[key].hasOwnProperty('DataVerificationResult') && Object.keys(response[key].DataVerificationResult).length > 0) {
          reject(response[key])
        } else if (response[key].hasOwnProperty('LimitsExceeded') && Object.keys(response[key].LimitsExceeded).length > 0) {
          reject(response[key])
        } else {
          reject(response[key].ErrorDescription._text)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/_responseParser.js